import { render, staticRenderFns } from "./quesSuccess8_1.vue?vue&type=template&id=b98bafce"
import script from "./quesSuccess8_1.vue?vue&type=script&lang=js"
export * from "./quesSuccess8_1.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess8_1.vue?vue&type=style&index=0&id=b98bafce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports